<template>
  <v-container fluid>
    <div class="issues-report mt-10">
      <v-card class="px-6 pb-0 mb-3">
        <v-row>
          <!-- <v-col md="3"><v-text-field v-model="start_date"></v-text-field></v-col>
          <v-col md="3"><v-text-field v-model="end_date"></v-text-field></v-col>-->
          <v-col md="3" class="pb-0">
            <v-menu ref="menu" v-model="menu_start" :close-on-content-click="false" transition="scale-transition"
              offset-y min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :value="dateFormatted(start_date)" :label="$t('start_date')" prepend-icon="mdi-calendar" readonly
                  v-on="on" color="primary"></v-text-field>
              </template>
              <v-date-picker v-model="start_date" @change="onStartDateChange" no-title scrollable :locale="$t('locale')"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="3" class="pb-0">
            <v-menu ref="menu" v-model="menu_end" :close-on-content-click="false" transition="scale-transition" offset-y
              min-width="290px">
              <template v-slot:activator="{ on }">
                <v-text-field :value="dateFormatted(end_date)" :label="$t('end_date')" prepend-icon="mdi-calendar" readonly
                  v-on="on" color="primary"></v-text-field>
              </template>
              <v-date-picker v-model="end_date" @change="onEndDateChange" :min="start_date" no-title scrollable :locale="$t('locale')"></v-date-picker>
            </v-menu>
          </v-col>
          <v-col md="3" class="pa-6">
            <v-btn block color="primary" @click="getSummary(1, itemPerPage, groupId, userId)">
              <v-icon>mdi-magnify</v-icon>{{$t('search')}}
            </v-btn>
          </v-col>
          <v-col md="3" class="pa-6">
            <v-btn @click="downloadUserSummary()" block outlined color="primary">
              <v-icon>mdi-download</v-icon>
              {{$t('download_report')}}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>

      <v-card class="mt-5">
        <v-card-title>
          <v-row justify="end">
            <v-col md="3">
              <v-autocomplete :label="$t('group')" :items="groupList" v-model="groupId" item-text="name" item-value="id"
                v-on:change="onSelectGroup"></v-autocomplete>
            </v-col>
            <v-col md="3">
              <v-autocomplete :label="$t('find_a_user')" :items="userListSummary" :rules="[validator.alfaNumberNotRequired]" v-model="userId" item-text="full_name"
                item-value="id" :loading="loadingSummary" v-on:change="onSelectUser"></v-autocomplete>
            </v-col>
          </v-row>
        </v-card-title>

        <v-data-table :loading="loading" :headers="headers" :items="dataSummary" :server-items-length="totalData"
          :items-per-page.sync="itemPerPage" :footer-props="{ 'items-per-page-options': [10, 50, 100], 'items-per-page-text': $t('rows_per_page') }" :page="page"
          :sort-desc="[false]" :sort-by="['user_name']" @update:page="getSummary($event, itemPerPage)"
          @update:items-per-page="getSummary(page, $event)" :no-data-text="$t('no_data')">
          <template v-slot:group.groupName="{ items }">
            <span>
              {{}}
            </span>
          </template>
          <template v-slot:footer.page-text="items"> {{ items.pageStart }} - {{ items.pageStop }} {{$t('of')}} {{ items.itemsLength }} </template>
        </v-data-table>
        <!-- <template v-slot:item.is_corrected="{ item }">
          <div v-if="item.is_corrected != false">
            Data Correction
          </div>
          <div v-else>
            Data Normal
          </div>
        </template>-->
      </v-card>
    </div>
  </v-container>
</template>
<script>
  import axios from "axios";
  // import firebase from "firebase";
  import moment from "moment";
  export default {
    name: "issues-report",
    data() {
      return {
        downloadData: [],
        baseUrl: this.$store.state.baseUrl,
        reportUrl: this.$store.state.reportUrl,
        company_id: this.$store.state.company,
        group_id: this.$store.state.group_id,
        validator: this.$store.state.validator,
        menu_start: false,
        menu_end: false,
        start_date: "",
        end_date: "",
        userListSummary: [],
        userId: null,
        dataSummary: [],
        attendances: [],
        user_list: [],
        headers: [
          // { text: "Code", value: "employee_code" },
          { text: this.$i18n.t('employee_name'), value: "full_name" },
          { text: this.$i18n.t('position'), value: "position" },
          { text: this.$i18n.t('groupName'), value: "group_name" },
          { text: this.$i18n.t('on_time'), value: "on_time" },
          { text: this.$i18n.t('in-tolerance'), value: "tolerance_time" },
          { text: this.$i18n.t('late'), value: "late" },
          { text: this.$i18n.t('leave'), value: "leave" },
          { text: this.$i18n.t('correction_time'), value: "correction_time" },
          { text: this.$i18n.t('in_location'), value: "on_location" },
          { text: this.$i18n.t('tolerance_location'), value: "tolerance_location" },
          { text: this.$i18n.t('out_of_location'), value: "out_of_location" },
          { text: this.$i18n.t('correction_location'), value: "correction_location" },
          { text: this.$i18n.t('total_present'), value: "total_present" },
          { text: this.$i18n.t('absent'), value: "absent" },
        ],
        user_summary: [],
        loading: true,
        loadingSummary: true,
        loadingDownload: true,
        search: "",
        page: 1,
        itemPerPage: 10,
        totalData: 0,
        usersLength: 0,
        usersReportFiltered: [],
        search_user: "",
        groupId: null,
        groupList: []
      };
    },
    methods: {
      getDownloadTitle() {
        const companyName = this.$store.state.companyName;
        const date = moment().format("DDMMYYYYhhMM");
        return `Report User Summary ${companyName} - ${date}.xls`;
      },
       async downloadUserSummary() {
        this.loadingDownload = true
        const startDate = moment(this.start_date).format("DD-MM-YYYY");
        const endDate = moment(this.end_date).format("DD-MM-YYYY");
        let url = `companyId=${this.company_id}&startDate=${startDate}&endDate=${endDate}`
        if (this.groupId) url = `${url}&groupId=${this.groupId}`;
        if (this.userId) url = `${url}&userId=${this.userId}`
        await this.$store.dispatch('getDownloadUserSummary', url)
        this.loadingDownload = false
      },
      // filteredUser(data) {
      //   if (this.usersLength != data.length) {
      //     this.usersLength = data.length;
      //     this.usersReportFiltered = [];
      //     data.map((row) => {
      //       const user = {
      //         EmployeeCode: row.employee_code,
      //         Name: row.full_name,
      //         Email: row.email,
      //         Position: row.job_position,
      //         Level: row.level
      //       };
      //       this.usersReportFiltered.push(user);
      //     });
      //   }
      // },
      async onSelectGroup(groupId) {
        this.userId = null;
        await this.getSummary(1, this.itemPerPage, groupId, this.userId)
        await this.getUserSummary(groupId)
      },
      async onSelectUser(userId) {
        await this.getSummary(1, this.itemPerPage, this.groupId, userId)
      },
      onStartDateChange() {
        const diff = moment(this.end_date).diff(this.start_date, 'days')
        if (diff < 0) this.end_date = this.start_date
        this.menu_start = false;
      },
      onEndDateChange() {
        this.menu_end = false;
      },
      dateFormatted(date) {
        return moment(date).locale(this.$i18n.t('lang')).format("Do MMMM YYYY");
      },
      async fetchAttendances(group_id = null) {
        this.loading = true;
        let date_start = moment(this.start_date).format("DD-MM-YYYY");
        let date_end = moment(this.end_date).format("DD-MM-YYYY");
        let role = this.$store.state.role;
        if (group_id != null) this.group_id = group_id
        let params = {
          startDate: date_start,
          endDate: date_end,
          isPartial: false,
          page: 1,
          pageSize: 1500
        }

        if ((role === 0 || role === 2) && group_id == null) {
          params.companyId = this.company_id
          const result = await this.$store.dispatch('getReportAttendance', params)
          this.attendances = [];
          result.records.forEach((row) => {
            row.time_in = moment(row.time_in, "x").format("DD-MM-YYYY HH:mm");
            row.time_out = moment(row.time_out, "x").format("DD-MM-YYYY HH:mm");
            this.attendances.push(row);
          });
          this.createUserSummary();
          this.loading = false;
        } else if ((role === 3 || role === 4) || group_id != null) {
          params.groupId = this.group_id
          const result = await this.$store.dispatch('getReportAttendance', params)
          this.attendances = [];
          result.records.forEach((row) => {
            row.time_in = moment(row.time_in, "x").format("DD-MM-YYYY HH:mm");
            row.time_out = moment(row.time_out, "x").format("DD-MM-YYYY HH:mm");
            this.attendances.push(row);
          })
          this.createUserSummary();
          this.loading = false;
        }
      },
      async fetchGroupHierarchy() {
        const result = await this.$store.dispatch('getGroupListById', {
          id: this.group_id
        })
        this.groupList = result
        this.groupList.unshift({
          name: this.$i18n.t('all'),
          id: null
        })
      },
      async getUserList(page = 1, itemPerPage = 10, group_id = null) {
        let role = this.$store.state.role;
        this.loading = true
        this.page = page;
        this.itemPerPage = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page - 1;
        if (group_id) this.group_id = group_id
        if ((role === 0 || role === 2) && group_id == null) {
          const params = {
            companyId: this.company_id,
            page: start,
            pageSize: this.itemPerPage,
            fullName: this.search_user
          }
          const result = await this.$store.dispatch('getEmployeeList', params)
          this.totalData = result.count;
          this.users = result.rows;
          this.user_list = [];
          result.rows.forEach((row) => {
            if (row.role != 2) {
              this.user_list.push(row);
            }
          });
          this.loading = false;
          this.createUserSummary();
          return result
        } else if ((role === 3 || role === 4) || group_id != null) {
          const result = await this.$store.dispatch('getEmployeeListByGroup', {
            groupId: this.group_id
          })
          this.totalData = result.count;
          this.users = result;
          this.user_list = [];
          result.forEach((row) => {
            if (row.role != 2) {
              this.user_list.push(row);
            }
          });
          this.loading = false;
          this.createUserSummary();
          return result
        }
      },
      createUserSummary() {
        let role = this.$store.state.role;
        if (role === 0 || role === 2) {
          (this.user_summary = []),
          this.user_list.forEach((user) => {
            let summary = {
              employee_code: "",
              user_name: "",
              on_time_count: 0,
              time_tolerance_count: 0,
              late_count: 0,
              in_location_count: 0,
              location_tolerance_count: 0,
              out_location_count: 0,
              is_corrected_count: 0,
            };
            summary.position = user.job_position
            summary.groupName = this.getGroupName(user.groupId)
            summary.employee_code = user.employee_code;
            summary.user_name = user.full_name;
            summary.is_corrected = user.is_corrected;
            this.attendances.forEach((row) => {
              if (user.id == row.userId) {
                if (row.reason_in === "On-Time") {
                  summary.on_time_count += 1;
                }
                // else {
                //   if (row.reason_in === "In-Tolerance") {
                //     summary.time_tolerance_count += 1;
                //   } else {
                //     summary.late_count += 1;
                //   }
                // }
                else if (row.reason_in == "In-Tolerance") {
                  summary.time_tolerance_count += 1;
                } else if (row.reason_in == "Others") {
                  summary.late_count += 1;
                } else if (row.reason_in == "Meeting") {
                  summary.late_count += 1;
                } else if (row.reason_in == "Incident") {
                  summary.late_count += 1;
                }
                if (row.note_in === "In-Area") {
                  summary.in_location_count += 1;
                } else {
                  if (row.note_in === "GPS Error") {
                    summary.location_tolerance_count += 1;
                  } else {
                    summary.out_location_count += 1;
                  }
                }
                if (row.is_corrected == true) {
                  summary.is_corrected_count += 1;
                }
              }
            });
            this.user_summary.push(summary);
          });

          this.mapUserSummary(this.user_summary);
          return this.user_summary
        } else if (role === 3 || role === 4) {
          (this.user_summary = []),
          this.user_list.forEach((user) => {
            let summary = {
              employee_code: "",
              user_name: "",
              on_time_count: 0,
              time_tolerance_count: 0,
              late_count: 0,
              in_location_count: 0,
              location_tolerance_count: 0,
              out_location_count: 0,
              is_corrected_count: 0,
            };
            summary.position = user.job_position
            summary.groupName = this.getGroupName(user.groupId)
            summary.employee_code = user.employee_code;
            summary.user_name = user.full_name;
            summary.is_corrected = user.is_corrected;
            this.attendances.forEach((row) => {
              if (user.id == row.userId) {
                if (row.reason_in === "On-Time") {
                  summary.on_time_count += 1;
                }
                // else {
                //   if (row.reason_in === "In-Tolerance") {
                //     summary.time_tolerance_count += 1;
                //   } else {
                //     summary.late_count += 1;
                //   }
                // }
                else if (row.reason_in == "In-Tolerance") {
                  summary.time_tolerance_count += 1;
                } else if (row.reason_in == "Others") {
                  summary.late_count += 1;
                }
                if (row.note_in === "In-Area") {
                  summary.in_location_count += 1;
                } else {
                  if (row.note_in === "GPS Error") {
                    summary.location_tolerance_count += 1;
                  } else {
                    summary.out_location_count += 1;
                  }
                }
                if (row.is_corrected == true) {
                  summary.is_corrected_count += 1;
                }
              }
            });
            this.user_summary.push(summary);
          });
          this.mapUserSummary(this.user_summary)
          return this.user_summary;
        }
      },
      getGroupName(groupId) {
        const result = this.groupList.find(e => {
          if (e.id == groupId) {
            return e
          }
        })
        if (result) {
          return result.name
        } else {
          return result
        }
      },
      mapUserSummary(data) {
        const result = []
        data.map(item => {
          result.push({
            [this.$i18n.t('employeeCode')]: item.employee_code,
            [this.$i18n.t('employee_name')]: item.user_name,
            [this.$i18n.t('position')]: item.position,
            [this.$i18n.t('group')]: item.groupName,
            [this.$i18n.t('total_on_time')]: item.on_time_count,
            [this.$i18n.t('total_in_tolerance')]: item.time_tolerance_count,
            [this.$i18n.t('total_late')]: item.late_count,
            [this.$i18n.t('total_corrected')]: item.is_corrected_count,
            [this.$i18n.t('total_in_location')]: item.in_location_count,
            [this.$i18n.t('total_tolerance_location')]: item.location_tolerance_count,
            [this.$i18n.t('total_out_of_location')]: item.out_location_count
          })
        })
        this.downloadData = result.sort((v1, v2) => {
          if (v1['Employee Name'].toLowerCase() < v2['Employee Name'].toLowerCase()) {
            return -1;
          }
          if (v1['Employee Name'].toLowerCase() > v2['Employee Name'].toLowerCase()) {
            return 1;
          }
          return 0;
        })
        return data
      },
      async getSummary(page = 1, itemPerPage = 10, groupId = null, userId = null) {
        this.getUserSummary();
        this.loading = true
        this.loadingSummary = true
        this.loadingDownload= true
        this.page = page
        this.itemPerPage = itemPerPage
        this.groupId = groupId
        const totalPageSend = itemPerPage < 1 ? this.totalData : itemPerPage;
        const start = this.page;
        const dateStart = moment(this.start_date).format('DD-MM-YYYY')
        const dateEnd = moment(this.end_date).format('DD-MM-YYYY')

        let url =
          `${this.reportUrl}/usersummary/report?page=${start}&pageSize=${totalPageSend}&startDate=${dateStart}&endDate=${dateEnd}&companyId=${this.company_id}`
        if (groupId) {
          url = url + `&groupId=${groupId}`;
        }
        if (userId) {
          url = url + `&userId=${userId}`;
        }
        const result = await axios.get(url, {
          headers: {
            action: 'Get User Summary',
            actionId: 4
          }
        }).catch(e => {
          // eslint-disable-next-line no-console
          console.error(e.message)
          return null
        })
        if (result) {
          this.dataSummary = result.data.data.records
          this.totalData = result.data.data.total
        }
        this.loading = false
        this.loadingSummary = false
        this.loadingDownload = false
      },
      async getUserSummary(groupId = null) {
        this.loadingSummary = true
        this.groupId = groupId
        let url = `${this.baseUrl}/user/listbygroupid?companyId=${this.company_id}`
        if (groupId) {
          url = url + `&groupId=${groupId}`;
        }
        const result = await axios.get(url, {
          headers: {
            action: 'Get User Summary',
            actionId: 4
          }
        }).catch(e => {
          // eslint-disable-next-line no-console
          console.error(e.message)
          return null
        })
        if (result) {
          this.userListSummary = result.data.data
           this.userListSummary.unshift({
          full_name: this.$i18n.t('all'),
          id: null
        })
        }
        this.loadingSummary = false
      }
    },
    mapUserSummary(data) {
      const result = []
      data.map(item => {
        result.push({
          [this.$i18n.t('employeeCode')]: item.employee_code,
          [this.$i18n.t('employee_name')]: item.user_name,
          [this.$i18n.t('position')]: item.position,
          [this.$i18n.t('group')]: item.groupName,
          [this.$i18n.t('total_on_time')]: item.on_time_count,
          [this.$i18n.t('total_in_tolerance')]: item.time_tolerance_count,
          [this.$i18n.t('total_late')]: item.late_count,
          [this.$i18n.t('total_corrected')]: item.is_corrected_count,
          [this.$i18n.t('total_in_location')]: item.in_location_count,
          [this.$i18n.t('total_tolerance_location')]: item.location_tolerance_count,
          [this.$i18n.t('total_out_of_location')]: item.out_location_count
        })
      })
      this.downloadData = result.sort((v1,v2) => { if (v1[this.$i18n.t('employee_name')].toLowerCase() < v2[this.$i18n.t('employee_name')].toLowerCase()) { return -1; } if (v1[this.$i18n.t('employee_name')].toLowerCase() > v2[this.$i18n.t('employee_name')].toLowerCase()) { return 1; } return 0; })
      return data
    },
  async created() {
    this.start_date = moment()
      .startOf("month")
      .format("YYYY-MM-DD");
    this.end_date = moment().format("YYYY-MM-DD");
    await this.fetchGroupHierarchy()
    await this.fetchAttendances();
    await this.getUserList();
    await this.createUserSummary();
    await this.getSummary();
  },
  }
</script>
